import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import moment from 'moment';

import { LoadingSpinner, Button } from '../../components/_shared';
import { getCertificate } from '../../service/certificate';
import { Container } from './Certificate.styled';

const Certificate = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const { certId } = useParams();
  const [error, setError] = useState(false);
  const [copyText, setCopyText] = useState('Copy Permalink');

  useEffect(() => {
    const fetchCertificate = async () => {
      try {
        const res = await getCertificate(certId);
        setData(res.data.data);
      } catch (err) {
        setError('Certification does not exist.');
      } finally {
        setLoading(false);
      }
    };

    fetchCertificate();
  }, [certId]);

  useEffect(() => {
    let to;

    if (copyText === 'Copied!') {
      to = setTimeout(() => setCopyText('Copy Permalink'), 1500);
    }

    return () => to && clearTimeout(to);
  }, [copyText]);

  const downloadCert = () => {
    const a = document.createElement('a');
    a.href = data.image;
    a.download = `${data.curriculum}_${data.user}.png`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const copyLink = () => {
    if (copyText === 'Copied!') return;

    const dummy = document.createElement('input');
    document.body.appendChild(dummy);
    dummy.setAttribute('value', window.location.href);
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);

    setCopyText('Copied!');
  };

  return (
    <div className="absolute bg-white w-screen h-screen flex items-center justify-center">
      {loading ? (
        <LoadingSpinner color="red" />
      ) : error ? (
        <div className="text-2xl text-red-100">{error}</div>
      ) : (
        <Container className="relative">
          <img className="w-full cert-img" src={data.image} alt="cert_img" />
          <div className="mt-3 flex justify-center">
            <Button
              type="misc"
              className="copy-btn"
              caption={copyText}
              onClick={copyLink}
            />
          </div>
          <div className="mt-3 flex justify-center">
            <Button
              type="misc"
              className="download-btn"
              caption="Download Certificate"
              onClick={downloadCert}
            />
          </div>
        </Container>
      )}
    </div>
  );
};

export default Certificate;
